var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      !_vm.dialogDistroy
        ? _c(
            "el-dialog",
            {
              staticClass: "realSendReceiveDialog",
              attrs: {
                no: "realSendReceiveDialog",
                visible: _vm.innerVisible,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                title: _vm.title,
                width: _vm.$selectByLang("360px", "400px"),
                top: "5vh"
              },
              on: {
                "update:visible": function($event) {
                  _vm.innerVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "130px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("WriteOff.settleAccountsTo") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "settlementCompanyId",
                          "method-params": { active: true },
                          "default-value":
                            Number(_vm.settlementCompanyId) || "",
                          "tag-name": _vm.tagName,
                          "custom-style": _vm.formItemWidth
                        },
                        on: { change: _vm.companyIdChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": _vm.$selectByLang("85px", "130px"),
                        "label-position": "left",
                        disabled: _vm.lockRecordButton
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.lbPayReceive + _vm.$t("WriteOff.method")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              no: "receiveType",
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES,
                              cache: false,
                              "default-value": _vm.receiveType,
                              "static-options": _vm.receiveTypeArray,
                              "tag-name": _vm.tagName
                            },
                            on: { parentCallBack: _vm.receiveTypeChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("WriteOff.bankReceiptStatus") }
                        },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              no: "cashTransferState",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ClearingConstants$CASH_TRANSFER_STATES,
                              "callback-method-type": "value",
                              "default-value": _vm.cashTransferState,
                              "callback-params": { key: "cashTransferState" },
                              clearable: false,
                              "tag-name": _vm.tagName
                            },
                            on: {
                              parentCallBack: _vm.cashTransferStateChangeHandler
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_WriteOffHeader")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "actualAmountTitle",
                              "select-type":
                                _vm.selectTypeNames.static_data_InvoiceTitle,
                              filterable: "",
                              cache: false,
                              "default-value": _vm.actualAmountTitle,
                              "static-options": _vm.ourInvoiceTitleArray
                            },
                            on: {
                              parentCallBack: _vm.actualAmountTitleChangeEvent
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.ourSideBank") } },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              no: "ourBankAccountId",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.static_data_BankAccount,
                              cache: false,
                              "method-params": {
                                officeUuid: _vm.currentOfficeUuid
                              },
                              "default-value": _vm.ourBankAccountId,
                              "static-options": _vm.ourBankAccountArray,
                              "custom-label": _vm.ourBankAccountLabel,
                              "options-width": "450px"
                            },
                            on: { parentCallBack: _vm.ourBankChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.ourSideAccount") } },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            attrs: { no: "ourBankAccountNo", disabled: "" },
                            model: {
                              value: _vm.ourBankAccountNo,
                              callback: function($$v) {
                                _vm.ourBankAccountNo = $$v
                              },
                              expression: "ourBankAccountNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.proofNo") } },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            attrs: { no: "voucherNo" },
                            model: {
                              value: _vm.actualAmount.voucherNo,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "voucherNo", $$v)
                              },
                              expression: "actualAmount.voucherNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.showRecordButton
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { no: "actualAmountRecord", type: "primary" },
                          on: { click: _vm.actualAmountRecordHandler }
                        },
                        [_vm._v(_vm._s(_vm.recordButtonText))]
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": _vm.$selectByLang("85px", "130px"),
                        "label-position": "left",
                        disabled: _vm.lockRecordButton
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.currency") } },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              no: "currency",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              "default-value": _vm.currency,
                              clearable: false
                            },
                            on: { parentCallBack: _vm.currencyChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.lbAmount } },
                        [
                          _c("el-input-number", {
                            style: _vm.formItemWidth,
                            attrs: {
                              no: "amount",
                              min: 0,
                              precision: 2,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.actualAmount.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "amount", $$v)
                              },
                              expression: "actualAmount.amount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WriteOff.theOppositeSideCompany")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            attrs: { no: "paymentCompany" },
                            model: {
                              value: _vm.actualAmount.paymentCompany,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.actualAmount,
                                  "paymentCompany",
                                  $$v
                                )
                              },
                              expression: "actualAmount.paymentCompany"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WriteOff.theOppositeSideBank")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            attrs: { no: "companyBank" },
                            model: {
                              value: _vm.actualAmount.companyBank,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "companyBank", $$v)
                              },
                              expression: "actualAmount.companyBank"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WriteOff.theOppositeSideAccount")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            attrs: { no: "companyBankAccount" },
                            model: {
                              value: _vm.actualAmount.companyBankAccount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.actualAmount,
                                  "companyBankAccount",
                                  $$v
                                )
                              },
                              expression: "actualAmount.companyBankAccount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.lbPayDate } },
                    [
                      _c("el-date-picker", {
                        style: _vm.formItemWidth,
                        attrs: {
                          no: "payReceiveDate",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          clearable: false
                        },
                        model: {
                          value: _vm.actualAmount.payReceiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "payReceiveDate", $$v)
                          },
                          expression: "actualAmount.payReceiveDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.preRemarks") } },
                    [
                      _c("el-input", {
                        style: _vm.formItemWidth,
                        attrs: { no: "preRemark", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.actualAmount.preRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "preRemark", $$v)
                          },
                          expression: "actualAmount.preRemark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showTicketNo,
                          expression: "showTicketNo"
                        }
                      ],
                      attrs: { label: _vm.$t("Payment.ticketNo") }
                    },
                    [
                      _c("el-input", {
                        style: _vm.formItemWidth,
                        attrs: { no: "ticketNo", type: "text", maxlength: 30 },
                        model: {
                          value: _vm.actualAmount.ticketNo,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "ticketNo", $$v)
                          },
                          expression: "actualAmount.ticketNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "saveAndAdd", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveOrSaveAndAddHandler(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.saveAndAdd")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "save", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveOrSaveAndAddHandler(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "cancel" },
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            no: "realSendReceiveDialog2",
            visible: _vm.realSendReceiveDialog.visible,
            title: _vm.$t("Clearing.SelectActualReceiptAndPayment"),
            width: "1000px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            top: "4vh",
            "custom-class": "app-main-content"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.realSendReceiveDialog, "visible", $event)
            },
            closed: _vm.closedHandler
          }
        },
        [
          _vm.realSendReceiveDialog.visible
            ? _c("write-off-search", {
                ref: "searchItem",
                attrs: {
                  "config-module": "510",
                  "grid-config-module": "191002",
                  ar: _vm.realSendReceiveDialog.ar,
                  "is-prepay": _vm.realSendReceiveDialog.isPrepay,
                  "is-real-send-receive":
                    _vm.realSendReceiveDialog.isRealSendReceive,
                  "show-simple": false,
                  "grid-height": "height: 400px",
                  "is-dialog": true
                },
                on: {
                  clickedCallBack: function(row) {
                    return (_vm.realSendReceiveDialog.dialogClickRow = row)
                  }
                }
              })
            : _vm._e(),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.enterHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel2" },
                  on: {
                    click: function($event) {
                      _vm.realSendReceiveDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }